<template>
  <div class="dashboard">
    <div class="desc">Licznik</div>
    <div class="dashboard__inner">
      <div class="dashboard__bilans">
        <div class="dashboard__bilans__text">
          Bilans energetyczny
        </div>
        <div class="dashboard__value">
          <div>
            <span v-if="bilans > 0" class="sing sing--green">+</span>
            <span v-if="bilans < 0" class="sing sing--red">-</span>
            <span v-if="bilans == 0" class="sing"></span>
            <span class="dashboard__field">{{ Math.abs(Math.round(bilans)) }}</span>
          </div>
          <div class="dashboard__value__suffix">kWh</div>
        </div>
        <div class="dashboard__bilans__text">
          Stan energii
        </div>
        <div class="dashboard__bilans__controls">
          <div class="dashboard__control" v-bind:class="{'active': Math.round(bilans) > 0}">Nadwyżka do odbioru</div>
          <div class="dashboard__control" v-bind:class="{'active': powerStation }">Pobór energii od dostawcy</div>
        </div>
      </div>
      <div class="dashboard__counter">
        <Counter v-bind:name="'Zużycie'" v-bind:color="'red'" v-bind:percent="using" />
        <Counter v-bind:name="'Produkcja'" v-bind:color="'yellow'" v-bind:percent="production" />
      </div>
    </div>
  </div>
</template>

<script>
import Counter from "@/components/Counter";

export default {
  name: "Dashboard",

  props: {
    production: Number,
    using: Number,
    bilans: Number,
    powerStation: Boolean,
  },
  components: {
    Counter
  }
}
</script>

<style lang="scss">

#photovoltaics {
  .sing{
    display: inline-block;
    width: 20px;
    @include media-breakpoint-up(md) {
      width: 40px;
    }

    &--green{
      color: $green;
    }
    &--red{
      color: $red;
    }
  }

  .dashboard {
    grid-column: 1;
    grid-row: 3 / 6;
    @include media-breakpoint-up(md) {
      grid-column: 2 / span 2;
      grid-row: 3;
    }
    @include media-breakpoint-up(lg) {
      grid-column: 2;
    }

    &__inner{
      display: flex;
      flex-direction: column;
      //height: 100%;
      background: linear-gradient(to right, $blue-light, $blue-gradient);
      padding: 9px 8px;
      border-radius: 7px;
      color: $white;

      & > *{
        flex-grow: 1;
      }

      @include media-breakpoint-up(xl) {
        flex-direction: row;
      }
    }

    &__counter{
      display: flex;
      flex-direction: column;
    }

    @include media-breakpoint-up(xl) {
      flex-direction: row;
      &__counter{
        flex-direction: row;
        align-items: stretch;
        width: 50%;
        & > *{
          flex: 1;
        }
      }
    }


    &__control{
      font-size: 10px;
      font-weight: bold;
      margin-bottom: 0.3rem;
      border-radius: 7px;
      padding: 12px 8px;
      text-align: center;
      background: $blue-dark;
      color: $blue;

      &.active {
        border: 1px solid $green;
        padding: 11px 6px;
        background: rgba($green, 0.15);
        color: $green;
      }
    }

    &__value{
      display: flex;
      background: $blue-dark;
      border-radius: 7px;
      padding: 8px;
      font-size: 20px;
      justify-content: space-between;
      margin-bottom: 13px;
      &__suffix{
        align-self: center;
        color: $gray;
        font-size: 14px;
      }
    }

    &__bilans{
      &__text{
        font-weight: bold;
        margin-bottom: 0.5rem;
        font-size: 12px;
      }
      &__controls{
        margin-bottom: 6px;
      }

    }
  }
}
</style>
